const SHOPPING_CONTEXT_API = '/sitecore/api/ssc/rw/isagenix/shoppingcontextapi';
const RECOMMENDED_CART_API = '/sitecore/api/ssc/rw/isagenix/recommendedcartapi';

export async function setShoppingContextUrl(request) {
    let url = `${SHOPPING_CONTEXT_API}/SetShoppingContextUrl`;
    return $.ajax({
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function GetShareLinkCart(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    let url = `${RECOMMENDED_CART_API}/GetShareLinkCart`;
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        data: request
    });
}

export async function GetManageCart(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    let url = `${RECOMMENDED_CART_API}/GetManageCart`;
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export async function getProductPreview(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    var url = `${RECOMMENDED_CART_API}/GetProductPreview`;
    return $.ajax({
        headers: {
            __RequestVerificationToken: token,
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: request

    });
}

export async function saveShareImageModal(imagePath, sku) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    let requestData = {'ImagePath': imagePath, 'Sku': sku };
    return $.ajax({
        headers: {
            __RequestVerificationToken: token,
            'Content-Type': 'application/json'
        },
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/SaveShareImage`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(requestData)
    });
}

export async function saveRecommendedCart(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/SaveRecommendedCart`,
        data: data
    });
}

export async function saveShareLink(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/SaveProductShareLink`,
        data: data
    });
}

export async function loadRecommendedCart(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        contentType: 'application/json',
        url: `${RECOMMENDED_CART_API}/LoadRecommendedCart`,
        dataType: 'json',
        data: JSON.stringify(data)
    });
}

export async function LoadBundle(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        contentType: 'application/json',
        url: `${RECOMMENDED_CART_API}/LoadBundle`,
        dataType: 'json',
        data: JSON.stringify(data)
    });
}

export async function validateRecommendedCartProducts(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/validateRecommendedCartProducts`,
        data: data
    });
}

export async function updateShareLinkIsFavorite(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/UpdateShareLinkIsFavorite`,
        data: data
    });
}
export async function deleteRecommendedCart(data) {
    return $.ajax({
        headers: { __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val() },
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/deleteRecommendedCart`,
        data: data
    });
}

export async function updateRecommendedCartFlag() {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/UpdateRecommendedCartFlag`,
        headers: { __RequestVerificationToken: token }
    });
}

export async function updateBPFlags(isLinkFlow) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    let isLink = isLinkFlow === true;
    const actionName = isLink ? 'UpdateBPLinkFlowFlag' : 'UpdateBPBundleFlowFlag';
    return $.ajax({
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/${actionName}`,
        headers: { __RequestVerificationToken: token }
    });
}

export async function bulkDeleteRecommendedCart(data) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    return $.ajax({
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/bulkDeleteRecommendedCart`,
        headers: { __RequestVerificationToken: token },
        data: data
    });
}

export async function updateShareLinkModalFlag(shareCode) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    let shareLinkCodeModel = {shareCode: shareCode};
    return $.ajax({
        type: 'POST',
        url: `${RECOMMENDED_CART_API}/UpdateShareLinkModalFlag`,
        headers: { __RequestVerificationToken: token },
        data: shareLinkCodeModel
    });
}
